const Event = {
  _dispatch(event) {
    window.Beans3.Liana.View.CartButtonRenderer._containers.forEach(function (container) {
      const cartButton = container.target.firstElementChild;
      cartButton && cartButton.dispatchEvent(event);
    });

    window.Beans3.Liana.View.CheckoutButtonRenderer._containers.forEach(function (container) {
      const checkoutButton = container.target.firstElementChild;
      checkoutButton && checkoutButton.dispatchEvent(event);
    });

    window.Beans3.Liana.View.ProductButtonRenderer._containers.forEach(function (container) {
      const productButton = container.target.firstElementChild;
      productButton && productButton.dispatchEvent(event);
    });
  },
  /** Notify dynamic redemption status change so that the cart button gets updated
   *  detail => {coupon, status, message}
   *  status => done, error, pending:apply, pending:cancel
   * */
  dispatchRedemption(detail) {
    const event = new CustomEvent('event:liana:redemption', { detail });
    Event._dispatch(event);
  },
};

export default Event;
